import { resolveRenderCoverage } from './renderCoverage';
import { resolveRenderIdentity } from './renderIdentity';

const layoutShapeOf = (layout) => {
  const positions = layout?.definition?.positions || [];
  const byAxle = new Map();

  positions.forEach((position) => {
    const axle = Number(position.axle ?? position.axle_index);
    const fitment = position.fitment ?? position.fitment_type;
    if (!byAxle.has(axle)) byAxle.set(axle, []);
    byAxle.get(axle).push({ fitment });
  });

  return {
    axles: [...byAxle.entries()]
      .sort(([left], [right]) => left - right)
      .map(([index, positionsForAxle]) => ({
        index,
        fitment: positionsForAxle.some(({ fitment }) => fitment === 'dual' || ['inner', 'outer'].includes(fitment))
          ? 'dual'
          : 'single',
      })),
  };
};

const previewCoverageOf = (layout, findPreset) => {
  const identity = resolveRenderIdentity({ layout_template: layout });
  return resolveRenderCoverage(
    identity,
    { layout: layoutShapeOf(layout) },
    findPreset,
  );
};

export {
  layoutShapeOf,
  previewCoverageOf,
};
